<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="home">
    </v-container>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';

export default {
    name: 'home',
    data() {
        return {
            
        };
    },

    created() {
        //console.log('Home created');
        //console.log('route = ', this.$route);
        //this.$store.dispatch('tryAutoLogin');
        //this.$i18n.locale = 'es'; Parece que esto no es necesario
    },
    methods: {
        
    },
    computed: {
        ...mapGetters([
            'waitCursor',
            'isAuthenticated',
            'version',
        ]),    
    },
};
</script>



<style scoped>
.home {
    background: url('../assets/fondo.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}
.sub-window {
    /* background: rgba(89, 111, 133, 0.7); */
    background: rgba(0, 0, 0, 0.7);
    /* background: rgba(255, 255, 255, 0.5); */
}
.login-section {
    background: rgba(238, 238, 238, 0.85);
}
.tw-green {
    color: #006064;
    /* cyan darken-4 */
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>
